import '../../style/base.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/radio-group/style/index.js
// module id = 191
// module chunks = 0